module.exports = __webpack_public_path__ + "img/ic_chat_btn_store.ea9af5fe.svg";